import createUserData from '@app/state/data/partials/user'
import createMemberData from '@app/state/data/partials/member'
import createEventData from '@app/state/data/partials/event'
import createEventBookingData from '@app/state/data/partials/event_booking'
import { createUserCallback } from './helpers/callbacks/createUserCallback'

const user   = createUserData()
const member = createMemberData()
const eventBooking = createEventBookingData()

createUserCallback(user, member)

const event = createEventData()

export function createData(){
    return {
        user            : user,
        member          : member,
        event           : event,
        event_booking   : eventBooking
    }
}